// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueTranslate from 'vue-translate-plugin';
import vSelect from 'vue-select';
import VueAnalytics from 'vue-ua';
import App from './App';
import store from './store';
import router from './routes';

Vue.component(vSelect);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueTranslate);

// Vue.config.productionTip = false;


if (window.location.hostname.indexOf('booknatura.com') !== -1) {
  Vue.use(VueAnalytics, {
    appName: 'BookNatura', // Mandatory
    appVersion: '1.0', // Mandatory
    trackingId: 'UA-98416056-1', // Mandatory
    // debug: true, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  });
}
window.jQuery = window.$;

/* eslint-disable no-new */

window.vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js